import React from "react";
import CTA from "./CTA";
import "./Header.css";
import ME from "../../assets/me3.png";
import HeaderSocials from "./HeaderSocials";
import { CgScrollV } from "react-icons/cg";
import Typed from "react-typed";
function Header() {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Imane Boulouane</h1>
        <Typed
          className="text-light"
          strings={[
            "Frontend developer",
            "Backend developer",
            "Computer Science Engineer",
          ]}
          typeSpeed={40}
          backSpeed={60}
          loop
        />
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#about" className="scroll__down">
          <CgScrollV />
        </a>
      </div>
    </header>
  );
}

export default Header;
